<template>
	<div>
		<button @click="toreq">点击发送请求</button>
	</div>
</template>

<script>
	export default {
		methods: {
			toreq() {
				const data = {
					id: 24,
					username: "testuser",
					nickname: "testuser",
					password: 123456,
					userProfile: "987654",
					userStateId: 2,
					isEnabled: true,
					isLocked: false,
				};
				this.putRequest("/user/updateuser", data);
			},
		},
	};
</script>
